<template>
  <div class="container mx-auto px-4 pb-10"> 
    <!-- Form Section -->
    <div class="mt-6 max-w-[1400px] mx-auto bg-white p-6 rounded-lg shadow-lg">
      <form @submit.prevent="addQA" class="grid grid-cols-1 gap-4">
        
        <!-- 제목 입력 -->
        <div class="flex flex-col">
          <label for="qaTitle" class="text-xs font-medium text-gray-700 text-left mb-2">제　목<span class="text-red-500"> *</span></label>
          <input 
            v-model="form.title" 
            id="qaTitle" 
            type="text" 
            placeholder="글 제목" 
            class="w-full px-3 py-2 border rounded shadow-sm focus:outline-none focus:ring focus:ring-violet-200 placeholder:text-gray-400 text-[10px]"
            :class="{ 'border-red-500': errors.title }"
          />
          <p v-if="errors.title" class="text-red-500 text-xs mt-1">⚠ {{ errors.title }}</p>
        </div>

        <!-- 작성자 -->
        <div class="flex flex-col">
          <label for="qaAuthor" class="text-xs font-medium text-gray-700 text-left mb-2">작성자</label>
          <output 
            id="qaAuthor" 
            class="w-full px-3 py-2 border border-gray-300 rounded shadow-sm bg-gray-100 text-left text-[10px]"
          >
            {{ form.author }}
          </output>
        </div>
        

        <div class="flex flex-col">
          <label for="qaContent" class="text-xs font-medium text-gray-700 text-left mb-2">내　용<span class="text-red-500"> *</span></label>
          <Ckeditor class="ck-content"  v-model="form.content" />  <!-- v-model 추가 -->
          <!-- <textarea 
            v-model="form.content" 
            id="qaContent" 
            placeholder="글 내용을 입력하세요" 
            class="w-full px-3 py-2 border rounded shadow-sm focus:outline-none focus:ring focus:ring-violet-200 placeholder:text-gray-400 text-[10px]"
            :class="{ 'border-red-500': errors.content }"
            rows="10"
          ></textarea> -->
          <p v-if="errors.content" class="text-red-500 text-xs mt-1">⚠ {{ errors.content }}</p>
        </div>
        
        <!-- 내용 입력 -->
        <!-- <div class="flex flex-col">
          <label for="qaContent" class="text-xs font-medium text-gray-700 text-left mb-2">내　용<span class="text-red-500"> *</span></label>
          <textarea 
            v-model="form.content" 
            id="qaContent" 
            placeholder="글 내용을 입력하세요" 
            class="w-full px-3 py-2 border rounded shadow-sm focus:outline-none focus:ring focus:ring-violet-200 placeholder:text-gray-400 text-[10px]"
            :class="{ 'border-red-500': errors.content }"
            rows="10"
          ></textarea> 
          <p v-if="errors.content" class="text-red-500 text-xs mt-1">⚠ {{ errors.content }}</p>
        </div> -->

        <!-- 버튼 -->
        <div class="flex justify-center gap-4 mt-6">
          <button 
            type="button" 
            class="px-6 py-2 bg-gray-100 text-gray-700 text-sm font-medium rounded hover:bg-gray-200"
            @click="handListBtn" 
          >
            목록
          </button>
          <button 
            type="submit" 
            class="px-6 py-2 bg-red-500 text-white text-sm font-medium rounded hover:bg-red-600"
          >
            저장
          </button>
        </div>

      </form>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

import Ckeditor from '@/components/ui/Ckeditor.vue'

const store = useStore();
const router = useRouter();

// 사용자 정보
const user = computed(() => store.state.auth.user);

const form = reactive({
  title: '',
  author: `${user.value.name}`,  
  content: '',
});

const errors = reactive({
  title: '',
  content: '',
});

// 유효성 검사 함수 (대화박스 없이 오류 표시)
const validateForm = () => {
  errors.title = form.title.trim() ? '' : '제목을 입력해주세요!';
  errors.content = form.content.trim() ? '' : '내용을 입력해주세요!';

  return !errors.title && !errors.content;
};

const addQA = async () => {
  // 필수값 검증
  if (!validateForm()) return;

  try {
    const newProject = {
      title: form.title,
      content: form.content, 
      user_nm: form.author 
    };

    const result = await store.dispatch('insight/createInsightList', newProject);
    console.log(result);
    store.commit('handleNotify', { message: 'Q&A가 성공적으로 등록되었습니다.', type: 'success' });
    await router.push({ name: 'INSIGHTBoard' });
  }  
  catch (error) {
    store.commit('handleNotify', { message: 'Q&A 등록에 실패하였습니다.' });
  }
};

const handListBtn = async () => {
  await router.push({ name: 'INSIGHTBoard' });
};
</script>
